import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LinearProgress } from '@material-ui/core';

import { getTypeOrNull, useCommentQuery } from '@spotify/confidence-graphql';
import { useCommentState } from '@spotify/plugin-confidence-comments-react';

import { urlFromResource } from './utils';

const CommentsHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const resourcePath = decodeURIComponent(location.pathname).split('/')[2];
  const commentId = `comments/${resourcePath}`;
  const { data, error } = useCommentQuery({
    variables: {
      name: commentId,
    },
  });

  const showMenu = useCommentState(state => state.enterCommentMode);
  const selectComment = useCommentState(state => state.selectComment);

  useEffect(() => {
    if (error) {
      navigate('/', { replace: true });
      return;
    }

    const handleAccount = async () => {
      const comment = getTypeOrNull(data?.comment);
      const resource = comment?.resource;
      if (resource) {
        const newUrl = urlFromResource(resource);
        navigate(newUrl, { replace: true });
        showMenu();
        selectComment(commentId);
      }
    };

    handleAccount();
  }, [data, error, navigate, showMenu, selectComment, commentId]);

  return <LinearProgress />;
};

export default CommentsHandler;
